export const Footer = () => {
  return (
    <div className='footer'>
      <span>
        Developed by <a href='https://www.jameem.dev/'>Jameem Mohammed</a>
      </span>
      <div className='social'>
        <a href='https://github.com/Jameem'>
          <img src='github.png' alt='github' />
        </a>
        <a href='https://www.linkedin.com/in/jameem/'>
          <img src='linkedin.png' alt='linkedin' />
        </a>
      </div>
    </div>
  );
};
